window.addEventListener('load', function () {
    if (!document.body.classList.contains('home')) {
        setTimeout(function () {
            document.body.classList.add('page-loaded');
        }, 1000);
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const menuToggle = document.querySelector('.menu-toggle');
    const siteHeader = document.querySelector('.site-header');
    const siteMenu = document.querySelector('.site-header__menu');

    menuToggle.addEventListener('click', function () {

        if (siteHeader.classList.contains('site-header__menu-open')) {
            siteHeader.classList.remove('site-header__menu-open');
        } else {
            siteHeader.classList.add('site-header__menu-open');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const siteHeader = document.querySelector('.site-header');
    const branding = document.querySelector('.site-header__branding');
    if (!siteHeader) return;

    const isHome = document.body.classList.contains('home');

    if (!isHome) {
        siteHeader.classList.add('site-header--blend');
    }

    const updateHeaderState = function () {
        const scrolled = window.scrollY > 0;

        if (scrolled) {
            siteHeader.classList.add('site-header--blur');
        } else {
            siteHeader.classList.remove('site-header--blur');
        }

        if (isHome) {
            if (scrolled) {
                siteHeader.classList.add('site-header--blend');
            } else {
                siteHeader.classList.remove('site-header--blend');
            }
        }

        if (branding) {
            const expanded = window.scrollY === 0;
            branding.setAttribute('data-expanded', expanded ? 'true' : 'false');
            siteHeader.setAttribute('data-scrolled', expanded ? 'false' : 'true');
            siteHeader.setAttribute('data-expanded', expanded ? 'true' : 'false');
        }
    };

    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
});

document.addEventListener('DOMContentLoaded', function () {
    const subscribeButton = document.querySelector('.site-footer__subscribe-button');
    const footer = document.querySelector('.site-footer');
    if (!subscribeButton) return;

    subscribeButton.addEventListener('click', function () {
        if (!footer) return;
        footer.classList.toggle('site-footer--subscribe-open');
        const isOpen = footer.classList.contains('site-footer--subscribe-open');
        subscribeButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        const panel = footer.querySelector('.site-footer__subscribe-panel');
        if (panel) {
            panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        }
    });
});
document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('form');
    forms.forEach(function (form) {
        var arrow = form.querySelector('.submit-arrow');
        var checkbox = form.querySelector('.privacy-checkbox');
        if (!arrow || !checkbox) return;

        checkbox.addEventListener('change', function () {
            if (checkbox.checked) {
                arrow.classList.remove('disabled');
            } else {
                arrow.classList.add('disabled');
            }
        });

        arrow.addEventListener('click', function () {
            if (arrow.classList.contains('disabled')) return;
            var submitButton = form.querySelector('.newsletter-submit');
            if (submitButton) submitButton.click();
        });
    });
});

//  Add Submenu script
document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.menu-item-has-children');

    menuItems.forEach(function (item) {
        const link = item.querySelector(':scope > .site-nav__link');
        const submenu = item.querySelector(':scope > .site-nav__list');
        if (!link || !submenu) return;

        item.classList.add('has-submenu-toggle');

        if (item.querySelector(':scope > .site-nav__submenu-toggle')) return;

        const toggleButton = document.createElement('button');
        toggleButton.type = 'button';
        toggleButton.className = 'site-nav__submenu-toggle';
        toggleButton.setAttribute('aria-expanded', 'false');
        toggleButton.setAttribute('aria-label', 'Toggle submenu');
        link.insertAdjacentElement('afterend', toggleButton);

        toggleButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const isOpen = item.classList.toggle('active');
            toggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            submenu.style.display = isOpen ? 'block' : 'none';
        });
    });

    const menuToggle = document.querySelector('.menu-toggle');

    if (menuToggle) {
        menuToggle.addEventListener('click', function (e) {
            const menuItems = document.querySelectorAll('.menu-item-has-children');
            const submenus = document.querySelectorAll('.menu-item-has-children .site-nav__list');
            const toggles = document.querySelectorAll('.menu-item-has-children .site-nav__submenu-toggle');

            menuItems.forEach(item => {
                item.classList.remove('active');
            });

            submenus.forEach(submenu => {
                if (submenu) {
                    submenu.style.display = 'none';
                }
            });

            toggles.forEach(toggle => {
                toggle.setAttribute('aria-expanded', 'false');
            });
        });
    }
});

/**
 * Booking Popup functionality
 *
 * @package EauPalmBeach
 */
document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.querySelector('.booking-popup-trigger');
    const popup   = document.getElementById('booking-popup');

    if (!trigger || !popup) return;

    const overlay = popup.querySelector('.booking-popup__overlay');
    const closeBtn = popup.querySelector('.booking-popup__close');
    const tabs  = popup.querySelectorAll('.booking-popup__tab');
    const panes = popup.querySelectorAll('.booking-popup__pane');
    const cta   = popup.querySelector('.booking-popup__cta');

    function openPopup() {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('booking-popup--body-lock');
        closeBtn && closeBtn.focus();
    }

    function closePopup() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('booking-popup--body-lock');
        trigger.focus();
    }

    trigger.addEventListener('click', openPopup);

    if (overlay)  overlay.addEventListener('click', closePopup);
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (e) {
        if (!popup.classList.contains('is-open')) return;

        if (e.key === 'Escape') {
            closePopup();
            return;
        }

        if (e.key === 'Tab') {
            var focusable = Array.from(popup.querySelectorAll(
                'a[href], button:not([disabled]):not([tabindex="-1"]), [tabindex="0"]'
            )).filter(function (el) { return el.offsetParent !== null; });
            if (!focusable.length) return;
            var first = focusable[0];
            var last  = focusable[focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });

    var panel    = popup.querySelector('.booking-popup__panel');
    var body     = popup.querySelector('.booking-popup__body');
    var FADE_MS  = 300;

    tabs.forEach(function (tab, i) {
        tab.addEventListener('keydown', function (e) {
            var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
            if (!dir) return;
            e.preventDefault();
            var next = (i + dir + tabs.length) % tabs.length;
            tabs[next].focus();
            tabs[next].click();
        });
    });

    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
            var index    = this.dataset.tab;
            var isSingle = this.dataset.isSingle === 'true';
            var clickedTab = this;

            tabs.forEach(function (t) {
                t.classList.remove('is-active');
                t.setAttribute('aria-selected', 'false');
                t.setAttribute('tabindex', '-1');
            });
            clickedTab.classList.add('is-active');
            clickedTab.setAttribute('aria-selected', 'true');
            clickedTab.setAttribute('tabindex', '0');

            var currentPane = popup.querySelector('.booking-popup__pane.is-active');
            var newPane     = popup.querySelector('.booking-popup__pane[data-panel="' + index + '"]');

            if (currentPane === newPane) return;

            if (currentPane) {
                currentPane.classList.remove('is-active');
                currentPane.classList.add('is-leaving');
                currentPane.setAttribute('aria-hidden', 'true');

                var leaving = currentPane;
                setTimeout(function () {
                    leaving.classList.remove('is-leaving');
                }, FADE_MS);
            }

            setTimeout(function () {
                if (newPane) {
                    newPane.classList.add('is-active');
                    newPane.setAttribute('aria-hidden', 'false');
                }

                if (body) body.scrollTop = 0;

                if (panel) {
                    panel.classList.toggle('has-fixed-cta', isSingle);
                }

                if (cta && isSingle) {
                    var ctaUrl    = clickedTab.dataset.ctaUrl;
                    var ctaText   = clickedTab.dataset.ctaText;
                    var ctaTarget = clickedTab.dataset.ctaTarget;
                    if (ctaUrl)    cta.href        = ctaUrl;
                    if (ctaText)   cta.textContent = ctaText;
                    if (ctaTarget) cta.target      = ctaTarget;
                }
            }, FADE_MS * 0.6); // start incoming before outgoing finishes (overlap)
        });
    });
});

/**
 * Back to Top functionality
 *
 * @package EauPalmBeach
 */

(function () {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBackToTop);
    } else {
        initBackToTop();
    }

    /**
     * Initialize Back to Top button
     */
    function initBackToTop() {
        const backToTopButton = document.querySelector('.back-to-top-button');

        if (!backToTopButton) {
            return;
        }

        // Add click event listener
        backToTopButton.addEventListener('click', scrollToTop);
    }

    /**
     * Scroll to top of page with smooth animation
     */
    function scrollToTop(event) {
        event.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
})();

/**
 * Location Map functionality
 *
 * @package EauPalmBeach
 */
document.querySelectorAll('.ob-block-map__filter-label').forEach(function (filter_label) {
    filter_label.addEventListener('click', function () {
        this.parentNode.classList.toggle('is-menu-open');
    });
});
setTimeout(
    function () {
        document.querySelectorAll('.ob-block-map__type-image .ob-block-map__point').forEach(function (mark) {
            mark.addEventListener('mouseenter', function (ev) {
                this.click();
            });
        });
        var map_cards = document.querySelectorAll('.ob-block-map__type-image .ob-block-map__card');
        var map_pois = document.querySelectorAll('.ob-block-map__type-image .ob-block-map__point');
        map_cards.forEach(function (mark, i) {
            mark.addEventListener('mouseleave', function (ev) {
                this.querySelector('.ob-block-map__card__close').click();
            });
            let _top = map_pois[i].offsetTop;
            if (_top - (map_cards[i].offsetHeight / 2) < 0) {
                _top = (map_cards[i].offsetHeight / 2);
            }
            map_cards[i].style.left = map_pois[i].offsetLeft + 'px';
            map_cards[i].style.top = _top + 'px';
        });
    }, 300
)

/**
 * WAVE Accessibility fixes
 *
 * @package EauPalmBeach
 */
function wave_fix() {

    var headerSelectors = [
        '.site-nav__link',
        '.site-header__link',
        '.site-header__phone-label',
        '.site-header__menu-bottom-number',
    ].join(', ');
    document.querySelectorAll(headerSelectors).forEach(function (el) {
        el.style.backgroundColor = 'rgba(0, 0, 0, 0.009)';
    });

    document.querySelectorAll('textarea[name="g-recaptcha-response"]').forEach(function (textarea) {
        if (textarea.id && document.querySelector('label[for="' + textarea.id + '"]')) return;

        if (!textarea.id) {
            textarea.id = 'g-recaptcha-response-' + Math.random().toString(36).slice(2);
        }

        if (!document.querySelector('label[for="' + textarea.id + '"]')) {
            var label = document.createElement('label');
            label.setAttribute('for', textarea.id);
            label.textContent = 'reCAPTCHA';
            label.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
            textarea.parentNode.insertBefore(label, textarea);
        }
    });

    document.querySelectorAll(
        '.tribe-events-filter__checkbox-link input[type="checkbox"], ' +
        '.tribe-events-filter__checkbox-link input[type="radio"], ' +
        '.tribe-events-filter__radio-link input[type="radio"]'
    ).forEach(function (input) {
        if (input.getAttribute('aria-label')) return;
        var link = input.closest('.tribe-events-filter__checkbox-link, .tribe-events-filter__radio-link');
        if (!link) return;
        var text = link.textContent.trim();
        if (text) {
            input.setAttribute('aria-label', text);
        }
    });

}

// Run immediately in case reCAPTCHA is already in the DOM
document.addEventListener('DOMContentLoaded', wave_fix);

// Watch for reCAPTCHA injecting the textarea asynchronously after page load
(function () {
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                // Check if the added node itself is the recaptcha textarea
                if (node.matches && node.matches('textarea[name="g-recaptcha-response"]')) {
                    wave_fix();
                }
                // Check inside the added node for nested textareas
                if (node.querySelector && node.querySelector('textarea[name="g-recaptcha-response"]')) {
                    wave_fix();
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();

/**
 * Lazy load videos with class js-lazy-video.
 * Uses IntersectionObserver to load video src only when near viewport.
 */
(function () {
    var lazyVideos = document.querySelectorAll('video.js-lazy-video');
    if (!lazyVideos.length) return;

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var video = entry.target;
            video.querySelectorAll('source[data-src]').forEach(function (source) {
                source.src = source.dataset.src;
                source.removeAttribute('data-src');
            });
            video.load();
            observer.unobserve(video);
        });
    }, { rootMargin: '200px' });

    lazyVideos.forEach(function (video) {
        observer.observe(video);
    });
})();
